/* eslint-disable no-undef */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DropdownToggle, DropdownMenu, Dropdown } from 'reactstrap';
import { Link } from 'react-router-dom';
import SlideContainer from '../RecordViewer/SlideContainer';
import { withTranslation } from 'react-i18next';
import CustomizableModal from '../Common/Modal/CustomizableModal';

class UserProfileWidget extends Component {
  state = {
    componentReady: false,
    formulario: null,
    isOpenDrop: false
  };

  componentDidMount() {
    this.setState({ componentReady: true });
  }

  logout = () => {
    localStorage.removeItem('SHERPA_AUTH_JWT_ID');
    localStorage.removeItem('SHERPA_AUTH_JWT_ACCESS');

    // window.location.reload(true);
  };

  cerrarComponente = () => {
    this.setState({ formulario: null });
  };

  toggle = () => {
    this.setState({ isOpenDrop: !this.state.isOpenDrop });
  };

  cargarForm = async () => {
    this.toggle();
    const { default: CambiarContrasena } = await import('./CambiarContrasena');
    this.setState({
      formulario: (
        <CambiarContrasena cerrarModal={() => this.cerrarComponente()} />
      )
    });
  };
  render() {
    const { authInfo } = this.props;
    const imgSrc =
      authInfo.fotoPerfil != ''
        ? authInfo.fotoPerfil
        : require('../../styles/img/perfil_default.png');
    return (
      <>
        <Dropdown
          className={'perfilGadget'}
          isOpen={this.state.isOpenDrop}
          direction='left'
          toggle={() => this.toggle()}
        >
          {/* IMAGEN Y USUARIO (BOTON)*/}
          <DropdownToggle
            nav
            className='dropdown-toggle-nocaret dropdown--hover '
            onClick={() => this.setState({ formulario: null })}
          >
            <div
              className='row'
              style={{
                display: 'flex',
                width: 'fit-content',
                justifyContent: 'space-evenly'
              }}
            >
              <div className='imgProfile'>
                <div
                  className='img_profile_circle'
                  alt='Imagen de usuario'
                  style={{
                    height: '3vw',
                    width: '3vw',
                    borderRadius: '30px',
                    backgroundImage: 'url(' + imgSrc + ')',
                    backgroundPosition: 'center',
                    backgroundSize: 'cover'
                  }}
                />
              </div>
              <div
                style={{
                  display: 'grid',
                  paddingRight: '1vw',
                  fontSize: '1vw'
                }}
              >
                <label style={{ color: '#fff', margin: 0 }}>
                  {authInfo.nombre + '\n'}
                </label>
                <label
                  style={{
                    color: '#fff',
                    textTransform: 'uppercase',
                    fontSize: '0.8vw',
                    margin: 0
                  }}
                >
                  {authInfo.rol}
                </label>
              </div>
            </div>
          </DropdownToggle>

          {/* DATOS Y OPCIONES*/}
          <DropdownMenu
            className='dropdown-menu-right right container_info_profile custom-dropdown-menu'
            style={{ top: 'auto'}}
          >
            {/* Thumbnail e Info*/}
            <div className='info_profile'>
              <div
                className='img_profile'
                alt='Imagen de usuario'
                style={{
                  backgroundImage: 'url(' + imgSrc + ')'
                }}
              />
              <div className='ml-2 data_profile'>
                <h4 className='mb-0'>{authInfo.nombreUsuario}</h4>
                <p className=' mb-0'>{authInfo.correo}</p>
                {/* <a
                  href='profile.html'
                  className='btn btn-rounded btn-primary btn-sm'
                >
                  Ver Perfil
                </a> */}
              </div>
            </div>
            <div className='dropdown-divider'></div>

            {/* OPCIONES */}
            <div className='profile_options'>
              <a onClick={() => this.cargarForm()}>
                <i className='fas fa-lock'></i> Cambiar Contraseña
              </a>
            </div>

            <div className='dropdown-divider'></div>

            <div className='profile_options'>
              <Link
                onClick={this.logout}
                to='/login'
                style={{ color: '#9e0032' }}
              >
                <i className='fas fa-power-off'></i> Salir
              </Link>
            </div>

            <div className='dropdown-divider'></div>

            {/* VERSION */}
            <div className='profile_options'>
              <div className="simple-item">v{process.env.REACT_APP_VERSION}</div>
            </div>
          </DropdownMenu>
        </Dropdown>

        {/* CAMBIAR CONTRASEÑA */}
        {this.state.formulario && (
          <CustomizableModal
            width={'60%'}
            tittle={'Cambiar Contraseña'}
            icono='fas fa-user-alt'
            subTitulo=''
            setModal={this.cerrarComponente}
            modal={true}
          >
            {this.state.formulario}
          </CustomizableModal>
        )}
      </>
    );
  }
}

UserProfileWidget.propTypes = {
  t: PropTypes.func,
  authInfo: PropTypes.object.isRequired
};

export default withTranslation('account')(UserProfileWidget);
